import { WALL_OFFSET_THICKNESS, WALL_STANDARD_HEIGHT } from "../core/constants";
import { Dimensioning } from "../core/dimensioning";
import { EVENT_CORNER_CLICKED,EVENT_ROOM_DIMENSION_CLICKED, EVENT_NOTHING_SELECTED, EVENT_WALL_CLICKED, EVENT_WALL_DIMENSION_CLICKED, EVENT_ROOM_CLICKED, EVENT_ROOM_METADATA_CHANGED,EVENT_ICONS_CLICKED,EVENT_LABEL_CLICKED,EVENT_ARROW_CLICKED } from "../core/events";
import { EventDispatcher } from 'three';

export class FloorPlannerHelper extends EventDispatcher {
    constructor(floorplan, floorplanner) {
        super();
        this.__floorplan = floorplan;
        this.__floorplanner = floorplanner;

        this.__wallThickness = Dimensioning.cmToMeasureRaw(WALL_OFFSET_THICKNESS);
        this.__cornerElevation = Dimensioning.cmToMeasureRaw(WALL_STANDARD_HEIGHT);
        this.__roomName = 'A New Area';
        this.__factor = 1;
        this.__roomType = 'used';
        this.__baseColor = 0x000000;

        this.__iconRotation = 0;
        this.__iconScale = 1;

        this.__labelText = 'Label Text';
        this.__labelColor = '#000000';
        this.__labelFontSize = 18;
        this.__labelRotation = 0;
        

        /**
         * Store a reference to the model entities
         */
        this.__selectedWall = null;
        this.__selectedCorner = null;
        this.__selectedRoom = null;
        this.__selectedWallDimension = null;
        this.__selectedRoomDimension = null;
        this.__selectedIcon = null;
        this.__selectedLabel = null;
        this.__selectedArrow = null;
        /**
         * Store a reference to the viewer3d visual entities
         */
        this.__selectedWallEntity = null;
        this.__selectedCornerEntity = null;
        this.__selectedRoomEntity = null;
        this.__selectedWallDimensionEntity = null;
        this.__selectedRoomDimensionEntity = null;
        this.__selectedIconEntity = null;
        this.__selectedLabelEntity = null;
        this.__selectedArrowEntity = null;

        this.__nothingSelectedEvent = this.__resetSelections.bind(this);
        this.__cornerSelectedEvent = this.__cornerSelected.bind(this);
        this.__wallSelectedEvent = this.__wallSelected.bind(this);
        this.__wallDimensionSelectedEvent = this.__wallDimensionSelected.bind(this);
        this.__roomDimensionSelectedEvent = this.__roomDimensionSelected.bind(this);
        this.__iconSelectedEvent = this.__iconSelected.bind(this);
        this.__labelSelectedEvent = this.__labelSelected.bind(this);
        this.__arrowSelectedEvent = this.__arrowSelected.bind(this);
        this.__roomSelectedEvent = this.__roomSelected.bind(this);

        this.__floorplanner.addFloorplanListener(EVENT_NOTHING_SELECTED, this.__nothingSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_CORNER_CLICKED, this.__cornerSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_WALL_CLICKED, this.__wallSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_ROOM_CLICKED, this.__roomSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_WALL_DIMENSION_CLICKED, this.__wallDimensionSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_ICONS_CLICKED, this.__iconSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_LABEL_CLICKED, this.__labelSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_ARROW_CLICKED, this.__arrowSelectedEvent);
        this.__floorplanner.addFloorplanListener(EVENT_ROOM_DIMENSION_CLICKED, this.__roomDimensionSelectedEvent);
        
    }

    __resetSelections() {
        this.__selectedCorner = null;
        this.__selectedWall = null;
        this.__selectedRoom = null;
        this.__selectedCornerEntity = null;
        this.__selectedWallEntity = null;
        this.__selectedRoomEntity = null;
        this.__selectedWallDimension = null;
        this.__selectedWallDimensionEntity = null;
        this.__selectedRoomDimension = null;
        this.__selectedRoomDimensionEntity = null;
        this.__selectedIcon = null;
        this.__selectedIconEntity = null;
    }

    __cornerSelected(evt) {
        this.__resetSelections();
        this.__selectedCorner = evt.item;
        this.__selectedCornerEntity = evt.entity;
        this.__cornerElevation = Dimensioning.cmToMeasureRaw(this.__selectedCorner.elevation);
    }

    __wallSelected(evt) {
        this.__resetSelections();
        this.__selectedWall = evt.item;
        this.__selectedWallEntity = evt.entity;
        this.__wallThickness = Dimensioning.cmToMeasureRaw(evt.item.thickness);
    }

    __wallDimensionSelected(evt){
        this.__resetSelections();
        this.__selectedWallDimension = evt.item;
        this.__selectedWallDimensionEntity = evt.entity;
    }

    __roomDimensionSelected(evt){
        this.__resetSelections();
        this.__selectedRoomDimension = evt.item;
        this.__selectedRoomDimensionEntity = evt.entity;
    }

    __iconSelected(evt){
        this.__resetSelections();
        this.__selectedIcon = evt.item;
        this.__selectedIconEntity = evt.entity;
        this.__iconRotation = this.__selectedIcon.rotation;
        this.__iconScale = this.__selectedIcon.scale;
    }

    __labelSelected(evt){
        this.__resetSelections();
        this.__selectedLabel = evt.item;
        this.__selectedLabelEntity = evt.entity;
        this.__labelText = this.__selectedLabel.label.text;
        this.__labelColor = this.__selectedLabel.label.style.fill;
        this.__labelFontSize = this.__selectedLabel.label.style.fontSize;
        this.__labelRotation = this.__selectedLabel.label.rotation;
    }

    __roomSelected(evt) {
        this.__resetSelections();
        this.__selectedRoom = evt.item;
        this.__selectedRoomEntity = evt.entity;
        this.__roomName = evt.item.name;
        this.__factor = evt.item.factor;
        this.__roomType = evt.item.roomType;
        this.__baseColor = evt.item.baseColor;
    }

    __arrowSelected(evt){
        this.__resetSelections();
        this.__selectedArrow = evt.item;
        this.__selectedArrowEntity = evt.entity;
    }

    __nothingSelected() {
        this.__resetSelections();
    }

    undoActions(){
        this.__floorplan.undoActions();
    }

    deleteCurrentItem() {
        if (this.__selectedWall) {
            this.__selectedWall.remove();
            this.__resetSelections();
        }
        if (this.__selectedCorner) {
            this.__selectedCorner.remove();
            this.__resetSelections();
        }
        if (this.__selectedWallDimension) {
            this.__selectedWallDimension.wall.isDelete = true;
            this.__selectedWallDimension.remove();
            this.__resetSelections();
        }
        if (this.__selectedRoomDimension) {
            this.__selectedRoomDimension.room.isDelete = true;
            this.__selectedRoomDimension.remove();
            this.__selectedRoomDimension.room.floorplan.dispatchEvent({ type: EVENT_ROOM_METADATA_CHANGED, item: this.__selectedRoomDimension.room, value: this.__selectedRoomDimension.room.code } )
            this.__resetSelections();
        }
        if (this.__selectedIcon) {
            this.__selectedIcon.floorplan.removeIcon(this.__selectedIcon.icon);
            this.__selectedIcon.remove();
            this.__resetSelections();
        }

        if(this.__selectedArrow){
            this.__selectedArrow.floorplan.removeArrow(this.__selectedArrow.arrow);
            this.__selectedArrow.remove();
            this.__resetSelections();
        }

        if(this.__selectedLabel){
            this.__selectedLabel.floorplan.removeLabel(this.__selectedLabel.label);
            this.__selectedLabel.remove();
            this.__resetSelections();
        }

    }

    set wallThickness(value) {
        if (this.__selectedWall) {
            let cms = Dimensioning.cmFromMeasureRaw(value);
            this.__selectedWall.thickness = cms;
            this.__wallThickness = value;
        }
    }
    get wallThickness() {
        return Dimensioning.cmToMeasureRaw(this.__wallThickness);
    }

    set cornerElevation(value) {
        if (this.__selectedCorner) {
            let cms = Dimensioning.cmFromMeasureRaw(value);
            this.__selectedCorner.elevation = cms;
            this.__cornerElevation = value;
        }
    }
    get cornerElevation() {
        return Dimensioning.cmToMeasureRaw(this.__cornerElevation);
    }

    set roomName(value) {
        if (this.__selectedRoom) {
            if(this.__roomName === value){
                return;
            }
            this.__selectedRoom.name = value;
            this.__roomName = value;
            this.__floorplan.dispatchEvent({ type: EVENT_ROOM_METADATA_CHANGED, item: this.__selectedRoom, value: value } )
        }
    }
    get roomName() {
        return this.__roomName;
    }

    set roomFactor(value) {
        if (this.__selectedRoom) {
            if(this.__factor === value){
                return;
            }
            this.__selectedRoom.factor = value;
            this.__factor = value;
            this.__floorplan.dispatchEvent({ type: EVENT_ROOM_METADATA_CHANGED, item: this.__selectedRoom, value: value } )
        }
    }
    get roomFactor() {
        return this.__factor;
    }

    set roomType(value) {
        if (this.__selectedRoom) {
            if(this.__roomType === value){
                return;
            }
            this.__selectedRoom.roomType = value;
            this.__selectedRoom.baseColor = (value === 'living')? '#0000FF' : '#008000';
            this.__roomType = value;
            this.__floorplan.dispatchEvent({ type: EVENT_ROOM_METADATA_CHANGED, item: this.__selectedRoom, value: value,target:'Roomtype' } )
        }
    }
    get roomType() {
        return this.__roomType;
    }


    set iconRotation(value) {
        if (this.__selectedIcon) {
            this.__selectedIcon.rotation = value;
            this.__iconRotation = value;
        }
    }
    get iconRotation() {
        return this.__iconRotation;
    }

    set iconScale(value) {
        if (this.__selectedIcon) {
            this.__selectedIcon.scale = value;
            this.__iconScale = value;
        }
    }
    get iconScale() {
        return this.__iconScale;
    }



    set labelRotation(value) {
        if (this.__selectedLabel) {
            this.__selectedLabel.updateStyle(value,'rotation');
            this.__labelRotation = value;
        }
    }
    get labelRotation() {
        return this.__labelRotation;
    }

    set labelText(value) {
        if (this.__selectedLabel) {
            this.__selectedLabel.text = value;
            this.__labelText = value;
        }
    }
    get labelText() {
        return this.__labelText;
    }

    set labelColor(value) {
        if (this.__selectedLabel) {
            this.__selectedLabel.updateStyle(value,'color');
            this.__labelColor = value;
        }
    }
    get labelColor() {
        return this.__labelColor;
    }

    set labelFontSize(value) {
        if (this.__selectedLabel) {
            this.__selectedLabel.updateStyle(value,'fontsize');
            this.__labelFontSize = value;
        }
    }
    get labelFontSize() {
        return this.__labelFontSize;
    }

}